module.exports = __webpack_public_path__ + "img/2.caed8c1d.jpg";